export default __webpack_public_path__ + "3ae536047c099113846a27b445eacc6c.png";